import React from 'react';
import { User, FileEdit, Download, Sparkles } from 'lucide-react';
export function SynthiaWorkflowSection() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-gray-50" data-id="element-1203">
      <div className="max-w-7xl mx-auto" data-id="element-1204">
        {/* Headline */}
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 font-['Syne']" data-id="element-1205">
          How to govern AI reasoning
        </h2>

        {/* Workflow Steps - Centered */}
        <div className="flex justify-center" data-id="element-1206">
          <div className="grid grid-cols-1 md:grid-cols-[auto_30px_auto_30px_auto_30px_auto] gap-6 items-start" data-id="element-1207">
            {' '}
            {/* Step 1: Input */}
            <div className="flex flex-col items-center text-center" data-id="element-1208">
              <div className="mb-6 text-gray-400" data-id="element-1209">
                <User className="w-12 h-12" strokeWidth={1.5} data-id="element-1210" />
              </div>
              <h3 className="text-4xl font-bold text-[#0066FF] mb-4 font-['Syne']" data-id="element-1211">
                Input
              </h3>
              <p className="text-gray-700 leading-relaxed max-w-[180px]" data-id="element-1212">
                User or Agent sends a prompt (Role + Request identified).
              </p>
            </div>
            {/* Arrow 1 */}
            <div className="flex items-center justify-center self-center -mt-8 relative -left-3" data-id="element-1213">
              <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1214">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-1215" />
              </svg>
            </div>{' '}
            {/* Step 2: Compose */}
            <div className="flex flex-col items-center text-center" data-id="element-1216">
              <div className="mb-6 text-gray-400" data-id="element-1217">
                <FileEdit className="w-12 h-12" strokeWidth={1.5} data-id="element-1218" />
              </div>
              <h3 className="text-4xl font-bold text-[#0066FF] mb-4 font-['Syne']" data-id="element-1219">
                Compose
              </h3>
              <p className="text-gray-700 leading-relaxed max-w-[220px]" data-id="element-1220">
  Drawing from your library, Synthia composes{' '}
  <span className="font-bold" data-id="element-1221">
    contextually intelligent instructions
  </span>
  .
            </p>
            </div>
            {/* Arrow 2 */}
            <div className="flex items-center justify-center self-center -mt-8" data-id="element-1222">
              <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1223">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-1224" />
              </svg>
            </div>{' '}
            {/* Step 3: Inject */}
            <div className="flex flex-col items-center text-center" data-id="element-1225">
              <div className="mb-6 text-gray-400" data-id="element-1226">
                <Download className="w-12 h-12" strokeWidth={1.5} data-id="element-1227" />
              </div>
              <h3 className="text-4xl font-bold text-[#0066FF] mb-4 font-['Syne']" data-id="element-1228">
                Inject
              </h3>
              <p className="text-gray-700 leading-relaxed max-w-[180px]" data-id="element-1229">
                These instructions are given to the LLM pre-flight, before generation.
              </p>
            </div>
            {/* Arrow 3 */}
            <div className="flex items-center justify-center self-center -mt-8 relative -left-3" data-id="element-1230">
              <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1231">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" data-id="element-1232" />
              </svg>
            </div>{' '}
            {/* Step 4: Reason */}
            <div className="flex flex-col items-center text-center" data-id="element-1233">
              <div className="mb-6 text-gray-400" data-id="element-1234">
                <Sparkles className="w-12 h-12" strokeWidth={1.5} data-id="element-1235" />
              </div>
              <h3 className="text-4xl font-bold text-[#0066FF] mb-4 font-['Syne']" data-id="element-1236">
                Reason
              </h3>
              <p className="text-gray-700 leading-relaxed max-w-[180px]" data-id="element-1237">
                The LLM answers with complete contextual understanding.
              </p>
            </div>{' '}
          </div>
        </div>

        {/* Bracket under Compose and Inject with Synthia Label */}
        <div className="relative mt-6 flex justify-center" data-id="element-1238">
          <div className="relative w-full max-w-2xl" data-id="element-1239">
            {/* Bracket wrapper for Compose + Arrow + Inject */}
            <div className="relative" data-id="element-1240">
              {/* Left vertical line */}
              <div className="absolute left-8 top-0 w-0.5 h-6 bg-gray-300" data-id="element-1241"></div>
              {/* Bottom horizontal line */}
              <div className="absolute left-8 right-8 top-6 h-0.5 bg-gray-300" data-id="element-1242"></div>
              {/* Right vertical line */}
              <div className="absolute right-8 top-0 w-0.5 h-6 bg-gray-300" data-id="element-1243"></div>

              {/* Synthia label centered under bracket */}
              <div className="absolute left-1/2 -translate-x-1/2 top-8 whitespace-nowrap" data-id="element-1244">
                <span className="text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1245">
                  SYNTHIA
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Skip Synthia text - positioned below the workflow */}
        <div className="mt-16 text-center" data-id="element-1246">
          <p className="text-base text-[#0066FF] font-medium" data-id="element-1247">
            Without Synthia, you go from{' '}
            <span className="font-bold" data-id="element-1248">ungoverned input</span> to{' '}
            <span className="font-bold" data-id="element-1249">ungoverned reasoning.</span>
          </p>
        </div>
      </div>
    </section>;
}